import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { pageTitle } from '../redux/actions/home.actions';
import { getUserPlansDetails } from '../redux/actions/user.actions';
// import FloatingLeftNav from '../components/general/floatingLeftNav';
import AppConstants from '../appConstants';
import webServices from '../services/webServices';
// import chatImg from '../assets/images/sidebar-img1.svg';
import sendIcon from '../assets/images/Send_msg.svg';
import blockImg from '../assets/images/block.svg';
import heartSearch from '../assets/images/heart-search.svg';
import ageIcon from '../assets/images/Cake.svg';
// FREE MODE (sheet #19): PlanBadge is not rendered on member cards for now.
// import { PlanBadge, ResidenceCity, OriginState } from '../components/general/ProfileMeta';
import { ResidenceCity, OriginState } from '../components/general/ProfileMeta';
import Spinner from '../components/general/spinner';
import RoseSendPopup from './roseSendPopup';
import rose from '../assets/images/rose.svg';
import Back from '../assets/images/backicon.svg'
import NoActivePlanPopup from './noActivePlanPopup';
import RoseExceedPopup from './roseExceedPopup';
import DailyLikeRemainderForRosePopup from './dailyLikeRemainderForRosePopup';
import { authCall } from '../services';
import VerifiedNotificationPopup from './verifiedNotificationPopup';
import DailyLikeRemainderPopup from './dailyLikeRemainderPopup';
import PlanNotPurchasedPopup from './planNotPurchasedPopup';
import { decodeData } from '../helpers';

// This screen has always treated plan 9 alone as Premium (plan 10 shows as
// Basic here but Premium elsewhere). Kept as-is rather than silently changed.
// const MATCH_QUEUE_PREMIUM_PLANS = [9];

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

const convertHeightToFeetAndInches = (decimalHeight) => {
  if (!decimalHeight) return '';

  const feet = Math.floor(decimalHeight);
  const inches = Math.round((decimalHeight - feet) * 12);
  return `${feet}’ ${inches}”`;
};

const GridViewComponent = (props) => {
  const { matchData, handleSendRose, handleActionChat, handleClickUsers, profileCardClickHandler, history } = props;

  // const getProfileImage = () => 'no_Image.svg';
  const getProfileImage = (images) => images ?? 'no_Image.svg';

  const goToMatchQueue = () => history.push(AppConstants.routes.afterLogin);

  return (
    <>
      <div className='new_match_que'>
        {
          matchData.length > 0 ? (
            <div className='inner-container'>
              <div className='topbar'>
                <h3>My Matches</h3>
              </div>
              <div className='list_wrapper'>
                {matchData.map(userData => (
                  <div key={`grid-view-${userData.id}`} className='card' onClick={() => profileCardClickHandler(userData)} role='button' tabIndex={0} onKeyDown={() => { }}>
                    <figure>
                      <img src={process.env.REACT_APP_PIC_BASE_URL + getProfileImage(userData.profile_image)} alt="/" />
                    </figure>
                    <caption>
                      <div className='row align-end myMatches_new'>
                        <div className='col-8 pr-0'>
                          <div className='row'>
                            <div className='col-7'> <h3>{userData.first_name}</h3></div>
                            {/* FREE MODE (sheet #19): member badge hidden — <div className='col-5'><div className='vipDec'><PlanBadge user={userData} premiumPlanIds={MATCH_QUEUE_PREMIUM_PLANS} /></div></div> */}
                            <div className='col-7 even_des mt-2'><ResidenceCity address={userData?.addressObj} /></div>
                            <div className='col-5 even_des mt-2'><OriginState uDetails={userData?.uDetails} /></div>
                          </div>
                        </div>
                        <div className='col-4 '>
                          <div className='row'>
                            <div className='col-12'>
                              <div className='myMatchesBtnGroup'>
                                <div className='left' role='button' onClick={e => handleActionChat(userData, e)} onKeyDown={() => { }} tabIndex={0}>
                                  <div className='btn'>
                                    <img src={sendIcon} alt="/" />
                                  </div>
                                  <span>Chat</span>
                                </div>
                                <div className='right' role='button' onClick={e => { handleClickUsers(userData); handleSendRose(e); }} onKeyDown={() => { }} tabIndex={0}>
                                  <div className='btn'>
                                    <img src={rose} alt="/" />
                                  </div>
                                  <span>Send roses</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </caption>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className='no_match_founf-v2'>
              <div className='card'>
                <img className='heartsearch' src={heartSearch} alt="" />
                <h1>You Don’t Have Matches (Connections) Yet</h1>
                <div className='disc'>Start exploring profiles in your Discover tab, like your favourite matches, and see who likes you back. This is how you get matches.</div>
                <div className='step-wrap'>
                  <h2>How to get matches</h2>
                  <div className='box'>
                    <div className='num'>1</div>
                    <h2 className='head m-0'>Go to Discover</h2>
                    <div className='details'>Check out profiles waiting for you. Click on any profile to see more details.</div>
                  </div>
                  <div className='box'>
                    <div className='num'>2</div>
                    <h2 className='head m-0'>Like or Send Roses</h2>
                    <div className='details'>Show your interest by liking someone or surprising them with a Rose. Think of Roses as a super like…Roses send you to the top of the list, increasing your chances of getting matches faster.</div>
                  </div>

                  <div className='box'>
                    <div className='num'>3</div>
                    <h2 className='head m-0'>Mutual Interest</h2>
                    <div className='details'>If they like you back, it’s a match (you get a new match / connection). That person will appear here, in your my matches tab.</div>
                  </div>

                  <div className='box'>
                    <div className='num'>4</div>
                    <h2 className='head m-0'>Start Chatting</h2>
                    <div className='details'>Once matched, you can begin the exciting journey to learn more about each other through Lovrican Chat.</div>
                    <div className='tips_wrapper'>
                      <div className='note'>
                      Note: use Lovrican Chat for as long as possible. Don’t be quick to share your personal information (phone, email, social media links) until you have sufficiently gotten to know your new love interest.
                      </div>
                      <div>
                        <a href={`${process.env.REACT_APP_BASE_URL}/safety-tips`} className='tips' target='_blank' rel='noreferrer'>Learn more about Lovrican Safety Tips</a>
                      </div>
                    </div>
                  </div>

                  <button type='button' className='gotomatch' onClick={goToMatchQueue}>Go to Discover</button>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </>
  );
};

const SingleProfileViewComponent = (props) => {
  const {
    selectedData,
    handleActionView,
    handleSendRose,
    handleActionChat,
    setShowConfirmation,
    goBackBtnHandler
  } = props;

  return (
    <>
      <div className="row myMaches-mobile">
        <div className="col-md-12">
          <div className="largeScreen">
            <div className="djustify-content-center new_matches_design">
              <div className="inerSection MatchesWrapper">
                <div className='go_back_wrapper'>
                  <button type='button' onClick={() => goBackBtnHandler(null, false)} className="go_to_back"><img src={Back} alt="" /> go Back</button>
                </div>
                {selectedData && (
                  <>
                    <div className='image-slider-box d-inline-block'>
                      <div
                        className='inner'
                        aria-hidden="true"
                        onClick={() => handleActionView(selectedData)}
                        style={{ cursor: 'pointer' }}
                      >
                        {selectedData.rosesSentToMe > 0 && (
                          <div className="rose-container">
                            <div className="rose-inner row ">
                              {(() => {
                                const roseData = [];
                                for (
                                  let i = 1;
                                  i <=
                                  (selectedData.rosesSentToMe > 12
                                    ? 11
                                    : selectedData.rosesSentToMe);
                                  i++
                                ) {
                                  roseData.push(
                                    <div
                                      className="roseBox col-6"
                                      key={i}
                                    >
                                      <div className="rose-circle">
                                        {' '}
                                        <img
                                          src={rose}
                                          alt="Lovrican rose"
                                        />
                                      </div>
                                    </div>
                                  );
                                }
                                return roseData;
                              })()}
                              {selectedData.rosesSentToMe > 12 && (
                                <div className="roseBox col-6 ">
                                  <div className="rose-circle position-relative">
                                    <img src={rose} alt="Lovrican rose" />
                                    <div className="moreOption">
                                      +{selectedData.rosesSentToMe - 12}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        <img
                          className="slider-bck-img"
                          src={`${process.env.REACT_APP_PIC_BASE_URL}${selectedData.profile_image
                            ? selectedData.profile_image
                            : 'no_Image.svg'
                            }`}
                          alt='/'
                        />
                        <div className="row justify-content-between chatBoxWrapper">
                          <div className="col-12">
                            <div className="chatBox d-none">
                              <p className="heightCustomer">
                                {selectedData.user_age} •{' '}
                                {selectedData.height
                                  ? `${selectedData.height.replace(
                                    '.',
                                    "'"
                                  )}"`
                                  : ''}
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="chatBox">
                              <div
                                className="chatTool float-left"
                                aria-hidden="true"
                                onClick={(e) =>
                                  handleActionChat(selectedData, e)
                                }
                                type="button"
                              >
                                <img
                                  src={sendIcon}
                                  className="send-icon mr-2"
                                  alt=""
                                />
                                <p>
                                  <span className="innerChat position-relative">
                                    Chat
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="chatBox">
                              <div
                                className="chatTool float-right"
                                aria-hidden="true"

                                onClick={(e) => handleSendRose(e)}
                                type="button"
                              >
                                <img
                                  src={rose}
                                  className="send-rose"
                                  alt=""
                                />
                                <p>
                                  <span className="innerChat position-relative">
                                    Send Roses
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button onClick={() => handleActionView(selectedData)} className='view_profile' type='button'>View Profile</button>
                      </div>

                    </div>
                    <div className="user-detail-box d-inline-block v-top">
                      <div
                        className="filters-line text-right d-none"
                        aria-hidden="true"
                        onClick={() => setShowConfirmation(true)}
                      >
                        <span>Delete User</span>
                      </div>
                      <div className="usr-info-box ">
                        {/* <div className="filter" /> */}
                        <h5
                          className="cursor-pointer"
                          aria-hidden="true"
                          onClick={() => handleActionView(selectedData)}
                        >
                          <span className="match_name">
                            {selectedData.user_name}
                          </span>
                          {/* FREE MODE (sheet #19): member badge hidden — <span className='vipDec ml-3'><PlanBadge user={selectedData} iconOnly premiumPlanIds={MATCH_QUEUE_PREMIUM_PLANS} /></span> */}
                        </h5>

                        {selectedData.user_occupation ? (
                          <p className="occupation">
                            {selectedData.user_occupation}
                            {selectedData?.companyName
                              ? ` at ${selectedData?.companyName}`
                              : ''}
                          </p>
                        ) : (
                          <p className="about-dec missting_section_match">
                            Occupation to be added
                          </p>
                        )}

                        <p className="address pt-3">
                          {selectedData.user_add}
                        </p>
                        <div>
                          <p className="prf_height age_icon">
                            <img src={ageIcon} alt="/" />{' '}
                            {selectedData.user_age}
                          </p>
                          {selectedData.height && (
                            <p className="prf_height">
                              {convertHeightToFeetAndInches(selectedData.height)}
                            </p>
                          )}
                        </div>

                        {selectedData?.uDetails?.educationLabel && (
                          <div className="about-me-box">
                            <p className="head">Education:</p>
                            <p className="about-dec">
                              {selectedData?.uDetails?.educationLabel}
                              {selectedData?.uDetails?.whatStudy && ` (${selectedData?.uDetails?.whatStudy})`}
                              {selectedData?.uDetails?.schoolName && ` from ${selectedData?.uDetails?.schoolName}`}
                            </p>
                          </div>
                        )}

                        <div className="about-me-box pt-3">
                          <p className="head">About Me:</p>

                          {selectedData.about_us ? (
                            <p className="about-dec">
                              {selectedData.about_us}
                            </p>
                          ) : (
                            <p className="about-dec missting_section_match">
                              Intro summary to be added
                            </p>
                          )}
                        </div>

                        {selectedData?.uDetails?.origin1 && selectedData?.uDetails?.origin2 && selectedData?.uDetails?.origin3 && (
                          <div className="about-me-box">
                            <p className="head">My Roots:</p>
                            <p className="about-dec">
                              {JSON.parse(selectedData?.uDetails?.origin3).label}, {JSON.parse(selectedData?.uDetails?.origin2).label},{' '}
                              {JSON.parse(selectedData?.uDetails?.origin1).label}
                            </p>
                          </div>
                        )}

                        {selectedData?.uDetails?.lookingFor && (
                          <div className="about-me-box">
                            <p className="head">Looking for:</p>
                            <p className="about-dec">{selectedData?.uDetails?.lookingFor}</p>
                          </div>
                        )}

                        <div className="ul-li-box hobbies-wrapper">
                          <p className="head pb-2">Hobbies:</p>
                          {selectedData?.hobbies ? (
                            <ul className="color-list">
                              {selectedData?.hobbies.map((prop) => (
                                <li key={prop.label}>{prop.label}</li>
                              ))}
                            </ul>
                          ) : (
                            <ul className="color-list missting_section_match">
                              <li>Hobbies to be added</li>
                            </ul>
                          )}
                        </div>
                        <div className='blockUserProfile'>
                          <button type='button' className='btn btn-block' onClick={() => setShowConfirmation(true)}>
                            <span>Block this user</span>
                            <img src={blockImg} alt="block user" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MatchQueuePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const query = useQuery();
  const uidParamRef = useRef({ uid: null, isLoaded: false });
  const { planDetails, current } = useSelector((state) => state.user);
  const [matchData, setMatchData] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isSpinner, setIsSpinner] = useState(true);
  const [showRoseSend, setShowRoseSend] = useState(false);
  const [roseSent, setRoseSent] = useState(false);
  const [showActivePlan, setShowActivePlan] = useState(false);
  const [roseExceed, setRoseExceed] = useState(false);
  const [roseCountSend, setRoseCountSend] = useState(0);
  const [myTotalRoses, setMyTotalRoses] = useState(0);
  const [dailyLikeRemainderRose, setDailyLikeRemainderRose] = useState(false);
  const [dailyLikeRemainder, setDailyLikeRemainder] = useState(false);
  const [showPlanNotPurchased, setShowPlanNotPurchased] = useState({ status: false, popupType: 1 });
  const [userListingView, setUserListingView] = useState('grid-view');

  const handleClosePlanNotPurchased = () => setShowPlanNotPurchased({ status: false, popupType: 1 });

  const [verifyMsg, setVerifyMsg] = useState(false);
  const handleCloseVerifyMsg = () => setVerifyMsg(false);

  const matchedList = async () => {
    const resp = await webServices.getMyMatches();
    if (resp && resp.success === true) {
      setMatchData(resp.data);
      if (resp.data.length > 0) {

        if (uidParamRef.current.uid && uidParamRef.current.isLoaded === false) {
          uidParamRef.current.isLoaded = true;

          const uidIndex = resp.data.findIndex(row => `${row.user_id}` === `${uidParamRef.current.uid}`);
          if (uidIndex >= 0) {
            setSelectedData(resp.data[uidIndex]);
            setUserListingView('single-view');
            setTimeout(scrollToTop, 250);
          }
        } else if (userListingView === 'single-view') {
          setUserListingView('grid-view');
          setTimeout(scrollToTop, 250);
        }
      }
      setTimeout(() => {
        setIsSpinner(false);
      }, 400);
    }
  };
  const getMatchCount = async () => {
    // const resp = await webServices.getMatchCount();
    // if (resp && resp.success === true) {
    //   setMyMatchedCount(resp.data.count);
    // }
  };

  useEffect(() => {
    uidParamRef.current = { uid: null, isLoaded: false };
    const uid = Number.isNaN(+decodeData(query.get("uid"))) ? null : decodeData(query.get("uid"));
    if (uid) {
      uidParamRef.current.uid = uid;
    }

    matchedList();
  }, [location.search]);

  useEffect(async () => {
    dispatch(pageTitle('My Matches'));
    dispatch(getUserPlansDetails());
  }, []);

  const handleClickUsers = (details) => setSelectedData(details);

  const handleCloseDailyLikeRemainder = () => setDailyLikeRemainder(false);

  const handleActionChat = async (details, e) => {
    e.stopPropagation();
    const resp = await authCall('user/userCheckPermission', { action: 'chat' });
    if (resp.data === 'profileNotApproved') {
      history.push(AppConstants.routes.congratulations);
    } else if (resp.data === 'noActivePlan') {
      setShowActivePlan(true);
    } else if (resp.data === 'planNotPurchased') {
      setShowPlanNotPurchased({ status: true, popupType: (resp.otherData.totalMatchCounts > 0 ? 2 : 1) });
    } else {
      history.push({
        pathname: AppConstants.routes.chat,
        state: { userDetail: details }
      });
    }
  };

  const handleActionView = (details) => {
    history.push({
      pathname: AppConstants.routes.viewProfile,
      state: { userId: details.user_id }
    });
  };

  const handleConfirmFinal = async () => {
    const response = await webServices.userChatActions({
      toId: selectedData.user_id,
      status: 'Delete'
    });
    if (response && response.success) {
      toast.success(response.message);
      setShowConfirmation(false);
      matchedList();
      getMatchCount();
    }
  };

  const handleSendRose = async (e) => {
    e.stopPropagation();
    const resp = await authCall('user/userCheckPermission', { action: 'rose' });
    if (resp.data === 'roseAvailable') {
      setShowRoseSend(true);
    } else if (resp.data === 'profileNotApproved') {
      history.push(AppConstants.routes.congratulations);
    } else if (resp.data === 'showDailyLikeRemainderRose') {
      setDailyLikeRemainderRose(true);
    } else if (resp.data === 'showDailyLikeRemainder') {
      setDailyLikeRemainder(true);
    } else if (resp.data === 'showRosePurchase') {
      setShowRoseSend(true);
    } else if (resp.data === 'noActivePlan') {
      setShowActivePlan(true);
    } else {
      setShowRoseSend(true);
    }
  };

  const handleCloseRoseSend = () => {
    setShowRoseSend(false);
    setRoseSent(false);
  };

  const handleCloseRoseExceed = () => setRoseExceed(false);
  const handleCloseDailyLikeRemainderRose = () => setDailyLikeRemainderRose(false);

  const handleConfirmRoseSend = async (response) => {
    if (response.roses) {
      const { data, success } = await webServices.getMyRoses();
      if ((success && data.my_roses < 1) || data.my_roses < response.roses) {
        setShowRoseSend(false);
        setRoseExceed(true);
        setRoseCountSend(response.roses);
        setMyTotalRoses(data.my_roses);
      } else {
        const result = await webServices.userLike({
          userId: selectedData.user_id,
          action: 'roseForMatched',
          roses: response.roses
        });
        if (result.success) {
          setRoseSent(true);
        } else {
          setShowRoseSend(false);
        }
      }
    }
  };

  const handleCloseActivePlan = () => setShowActivePlan(false);

  const handleCheckVerified = (e) => {
    e.stopPropagation();
    setVerifyMsg(current?.status !== 'ACTIVE' || current?.phone === null || false);
  };

  const gridViewToggleHandler = (userData, switchToSingleView = true) => {
    setUserListingView(`${switchToSingleView ? 'single' : 'grid'}-view`);

    if (switchToSingleView) {
      handleClickUsers(userData);
    }

    setTimeout(scrollToTop, 250);
  };

  return (
    <>
      <div className="inner-wrapper-newdesign">
        {isSpinner ? (<Spinner active={isSpinner} />) : (
          <>
            {/* <FloatingLeftNav /> */}

            {
              userListingView === 'grid-view' ?
                <GridViewComponent
                  current={current}
                  history={history}
                  matchData={matchData}
                  handleSendRose={handleSendRose}
                  handleActionChat={handleActionChat}
                  handleClickUsers={handleClickUsers}
                  profileCardClickHandler={gridViewToggleHandler}
                /> :
                <SingleProfileViewComponent
                  current={current}
                  matchData={matchData}
                  selectedData={selectedData}
                  handleClickUsers={handleClickUsers}
                  handleActionView={handleActionView}
                  handleSendRose={handleSendRose}
                  handleActionChat={handleActionChat}
                  setShowConfirmation={setShowConfirmation}
                  handleCheckVerified={handleCheckVerified}
                  goBackBtnHandler={gridViewToggleHandler}
                />
            }
          </>
        )}
      </div>

      <Modal
        className="filter-model PlanStatusModel"
        show={showConfirmation}
        onHide={showConfirmation}
        centered
      >
        <Modal.Header>
          <Modal.Title className="w-100">
            <h5 className="modal-title text-center w-100">Block User</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Blocking &apos;{selectedData.first_name}&apos; means that you and
            &apos;{selectedData.first_name}&apos; will no longer be able to view
            each other&apos;s profile or communication with each other.
            This change is permanent and cannot be undone.
          </p>
          <div className="text-center">
            <button
              type="button"
              className="btn theme-btn themebtn1 mr-0"
              onClick={() => handleConfirmFinal()}
            >
              Yes, Block
            </button>
          </div>
          <div className="text-center">
            <button
              type="button"
              className="btn theme-btn themebtn2"
              onClick={() => setShowConfirmation(false)}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <RoseSendPopup
        modalStatus={showRoseSend}
        handleClose={handleCloseRoseSend}
        userData={selectedData}
        handleConfirmRoseSend={handleConfirmRoseSend}
        roseSent={roseSent}
        fromMatched
        handleCloseCancel={handleCloseRoseSend}
      />

      <NoActivePlanPopup
        modalStatus={showActivePlan}
        handleClose={handleCloseActivePlan}
      />

      <RoseExceedPopup
        modalStatus={roseExceed}
        userData={selectedData}
        // userDetails={current}
        roseCountSend={roseCountSend}
        myTotalRoses={myTotalRoses}
        handleClose={handleCloseRoseExceed}
        fromMatched
      />

      <DailyLikeRemainderForRosePopup
        modalStatus={dailyLikeRemainderRose}
        currentPlan={planDetails}
        userDetails={selectedData}
        handleClose={handleCloseDailyLikeRemainderRose}
      />

      <DailyLikeRemainderPopup
        modalStatus={dailyLikeRemainder}
        currentPlan={planDetails}
        userDetails={current}
        handleClose={handleCloseDailyLikeRemainder}
      />

      <VerifiedNotificationPopup
        modalStatus={verifyMsg}
        handleClose={handleCloseVerifyMsg}
        userDetails={current}
      />

      <PlanNotPurchasedPopup
        modalStatus={showPlanNotPurchased.status}
        handleClose={handleClosePlanNotPurchased}
        popupType={showPlanNotPurchased.popupType}
      />
    </>
  );
};

export default MatchQueuePage;
